
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'qbe-filter-detail',
    components: {},
    props: { details: { type: Object } },
    data() {
        return {}
    },
    async created() {},
    methods: {}
})
